import { Sheet, SheetHeader } from "@/components/TrackingWorksheet";
import { WbText } from "@/components/WorkbookFields";
import { nextAssessment, fmtLong } from "@/lib/dates";

import { BOOKING_URL } from "@/components/CoachInvite";

const Field = ({ label, hint, k, n = 2 }) => (
  <div className="avoid-break">
    <div className="text-[12px] font-semibold text-slate-900">{label} {hint && <span className="font-normal text-slate-500">({hint})</span>}</div>
    <WbText k={k} n={n} h="h-6" />
  </div>
);

export const NextStepPage = ({ data }) => (
  <Sheet testId="worksheet-final-page">
    <SheetHeader title="Looking Back & Next Step Planner" sub="Workbook · end of 3 months" data={data} />
    <h3 className="mt-4 font-display text-base font-bold text-slate-900">Looking back</h3>
    <div className="mt-1 space-y-2">
      <Field k="final_activities" label="What activities did I do, and what did my tracking show?" />
      <Field k="final_learned" label="What did I learn?" />
    </div>
    <div className="mt-4 rounded-lg border-2 border-[#1F4266] bg-[#1F4266]/5 p-3 text-sm" data-testid="retake-reminder">
      <span className="font-bold text-[#1F4266]">Reminder: retake the assessment.</span>{" "}
      Goal date: <span className="font-semibold text-slate-900" data-testid="final-next-assessment-date">{fmtLong(nextAssessment(data.submitted_at))}</span>
    </div>
    <h3 className="mt-4 font-display text-base font-bold text-slate-900">Next Step Planner</h3>
    <p className="text-xs text-slate-600">A 15–20 minute activity. Complete this worksheet page on your own or with a coach.</p>
    <div className="mt-2 space-y-2">
      <Field k="final_next_step" label="My next step" hint="small and clear action" />
      <Field k="final_when" label="When I will take it" hint="date and time" n={1} />
      <Field k="final_support" label="Support I need to take this step" />
      <Field k="final_obstacles" label="Likely obstacle(s)" />
      <Field k="final_grace" label="My grace plan" hint="what I will do if I stumble while pursuing my next step" />
    </div>
    <div className="avoid-break mt-4 flex items-center gap-4 rounded-lg border border-slate-300 p-3" data-testid="schedule-call-invite">
      <img src="/schedule-qr.png" alt="QR code to schedule a call" className="h-24 w-24 shrink-0" data-testid="schedule-qr" />
      <div className="text-sm text-slate-700">
        <div className="font-display text-base font-bold text-[#1F4266]">Want a coach alongside you?</div>
        Scan the code to schedule a call and plan your next step together.
        <div className="mt-1 break-all text-xs text-slate-500">
          <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="underline" data-testid="schedule-call-link">{BOOKING_URL}</a>
        </div>
      </div>
    </div>
  </Sheet>
);
